import { AbstractService } from "./ApiClient";
import { ApiRoutes } from "@typingsGenerator/ApiRoutes";
import CostDetailsDto = Cloud.RavenDB.Core.Dto.Costs.CostDetailsDto;
import BillingSummaryDto = Cloud.RavenDB.Core.Dto.Costs.BillingSummaryDto;
import BillingSummaryListDto = Cloud.RavenDB.Core.Dto.Costs.BillingSummaryListDto;
import IssuedInvoiceDetailsDto = Cloud.RavenDB.Core.Dto.Costs.IssuedInvoiceDetailsDto;

export default class BillingService extends AbstractService {
    getSummary = async (domainName: string): Promise<BillingSummaryDto> => {
        const costs = await this.query<BillingSummaryDto>(ApiRoutes.billing.billingSummary({ domainName }));
        return costs.data;
    };

    getSummaryListByYear = async (domainName: string, selectedYear: string): Promise<BillingSummaryListDto> => {
        const costs = await this.query<{ selectedYear: string }, BillingSummaryListDto>(
            ApiRoutes.billing.billingSummaryList({ domainName }),
            { selectedYear }
        );
        return costs.data;
    };

    getCostDetails = async (domainName: string, billedAsOf: string): Promise<CostDetailsDto> => {
        const details = await this.query<{ billedAsOf: string }, CostDetailsDto>(
            ApiRoutes.billing.costsDetails({ domainName }),
            {
                billedAsOf,
            }
        );
        return details.data;
    };

    getInvoiceDetails = async (domainName: string, invoiceId: string): Promise<IssuedInvoiceDetailsDto> => {
        const details = await this.query<IssuedInvoiceDetailsDto>(
            ApiRoutes.billing.invoiceDetails({ domainName, invoiceId })
        );
        return details.data;
    };

    chargeUpToPreviousBillingPeriod = async (domainName: string): Promise<void> => {
        await this.post<void>(ApiRoutes.billing.chargeUpToPreviousBillingPeriod({ domainName }));
    };
}
